// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-list ion-item:first-child {\n  margin-top: 3%;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/user-comment/user-comment.scss"],"names":[],"mappings":"AAEC;EACC,cAAA;AADF","sourcesContent":["\nion-list {\n\tion-item:first-child {\n\t\tmargin-top: 3%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
